import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import fileDownload from 'js-file-download';
import { Link } from 'react-router-dom';

import OpbMod from './OpbMod';
import OpbPreview from '../OpbState/OpbPreview';
import Pagination from '../Common/Pagination';
import { roles } from '../../constants';
import { commonService, opbMngService, opbcdtService } from '../../services';
import { alertActions } from '../../modules/alert';
import { utilHelper } from '../../helpers';
import { DamdangOrgSelect, DamdangOfficeSelect, SiteNameInput, ElvNoInput, OpbTypeSelect, SiteNumInputSiteFinder, OpbStatusSelect } from '../Common/InputBox';

class OpbMng extends Component {
    xlsLoading = false;
    mounted = true;

    constructor(props) {
        super(props);
        // 로그인 한 사람이 지사운영자 일 경우 해당 지사의 컨텐츠만 검색
        const { myInfo } = props;
        const isAdministratorRole = myInfo.myRole === roles.administratorRole;
        const damdang = myInfo.company.split(",");

        this.state = {
            opbSearch: {
                damdangOrg: (isAdministratorRole ? damdang[0] : ''),
                damdangRegion: (isAdministratorRole ? damdang[1] : ''),
                damdangOffice: (isAdministratorRole ? damdang[2] : ''),
                siteName: '',
                siteNum: '',
                opbNo: '',
                elvNo: '',
                boardCode: '',
                typeCode: '',
                opbStatus: ''
            },
            usedOpbSearch: null,
            orgCodes: [],
            regionCodes: [],
            officeCodes: [],
            boardCodes: [],
            typeCodes: [],
            opbStatusCodes: [],
            totalCount: '',
            listCount: 10,
            currentPage: 1,
            start: 1,
            totalPage: 1,
            siteFinder: false,
            isAdministratorRole,
            opbInfoList: '',
            selectedOpbInfo: null,
            open: false,
            isMobile: false,
        };

        this.setCommonCodes();
        this.setBoardCodes();
        this.setOpbInfoList();

        if (isAdministratorRole) {
            this.setOfficeCodes();
        }
    }

    stateRefresh = () => {
        // 초기화
        this.setState({
            opbSearch: {
                damdangOrg: (this.state.isAdministratorRole ? this.state.opbSearch.damdangOrg : ''),
                damdangRegion: (this.state.isAdministratorRole ? this.state.opbSearch.damdangRegion : ''),
                damdangOffice: (this.state.isAdministratorRole ? this.state.opbSearch.damdangOffice : ''),
                siteName: '',
                siteNum: '',
                opbNo: '',
                elvNo: '',
                boardCode: '',
                typeCode: '',
                opbStatus: ''
            },
            usedOpbSearch: null,
            regionCodes: (this.state.isAdministratorRole ? this.state.regionCodes : []),
            officeCodes: (this.state.isAdministratorRole ? this.state.officeCodes : []),
            typeCodes: [],
            listCount: 10,
            currentPage: 1,
            siteFinder: false
        }, () => { this.setOpbInfoList(); });
    };

    componentDidMount = () => {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    };

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
        this.mounted = false;
    }

    resize() {
        let isMobile = (window.innerWidth < 992);
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile: isMobile });
        }
    }

    setCommonCodes = async () => {
        commonService.findOrgCodes()
            .then(response => {
                this.setState({ orgCodes: response.data });
            })
            .catch(this.handleErrors);

        commonService.findRegionCodes()
            .then(response => {
                this.setState({ regionCodes: response.data });
            })
            .catch(this.handleErrors);

        commonService.findOpbStatusCodes()
            .then(response => {
                this.setState({ opbStatusCodes: response.data });
            })
            .catch(this.handleErrors);
    };

    setOfficeCodes = async () => {
        this.setState({
            opbSearch: {
                ...this.state.opbSearch,
                damdangOffice: (this.state.siteFinder ? this.state.opbSearch.damdangOffice : ''),
            },
            officeCodes: []
        });
        if (this.state.opbSearch.damdangOrg && this.state.opbSearch.damdangOrg !== "") {
            commonService.findOfficeCodes(this.state.opbSearch.damdangOrg)
                .then(response => {
                    const officeCodes = response.data.filter(office => office.code !== "");
                    this.setState({ officeCodes: officeCodes });
                })
                .catch(this.handleErrors);
        }
    };

    setBoardCodes = () => {
        commonService.findOpbTypeCodes()
            .then(response => {
                this.setState({ boardCodes: response.data });
            })
            .catch(this.handleErrors);
    };

    setTypeCodes = async () => {
        this.setState({
            opbSearch: {
                ...this.state.opbSearch,
                typeCode: ''
            },
            typeCodes: []
        });
        if (this.state.opbSearch.boardCode !== "") {
            let formData = new FormData();
            formData.append('parentCode', this.state.opbSearch.boardCode);

            commonService.findOpbTypeCodes(formData)
                .then(response => {
                    this.setState({ typeCodes: response.data });
                })
                .catch(this.handleErrors);
        }
    };

    setOpbInfoList = async () => {
        let formData = new FormData();
        const { damdangOrg, damdangRegion, damdangOffice, siteName, siteNum, opbNo, elvNo, boardCode, typeCode, opbStatus } = this.state.opbSearch;
        const { listCount, currentPage } = this.state;
        if (damdangOrg !== "") formData.append('damdangOrg', damdangOrg);
        if (damdangRegion !== "") formData.append('damdangRegion', damdangRegion);
        if (damdangOffice !== "") formData.append('damdangOffice', damdangOffice);
        if (siteName !== "") formData.append('siteName', siteName);
        if (siteNum !== "") formData.append('siteNum', siteNum);
        if (opbNo !== "") formData.append('opbNo', opbNo);
        if (elvNo !== "") formData.append('elvNo', elvNo);
        if (boardCode !== "") formData.append('boardCode', boardCode);
        if (typeCode !== "") formData.append('typeCode', typeCode);
        if (opbStatus !== "") formData.append('opbStatus', opbStatus);
        formData.append('listCount', listCount);
        formData.append('currentPage', currentPage);

        opbMngService.findOpbInfoList(formData)
            .then(response => {
                console.log("opbMng > setOpbInfoList 검색결과: ");
                console.log(response.data);
                this.setState({
                    totalCount: response.data.totalCount,
                    totalPage: response.data.totalPage,
                    currentPage: response.data.currentPage,
                    start: response.data.start,
                    opbInfoList: response.data.opbInfoList,
                    usedOpbSearch: this.state.opbSearch
                });
            })
            .catch(this.handleErrors);
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.opbSearch.damdangOrg !== this.state.opbSearch.damdangOrg) {
            this.setOfficeCodes();
        }
        if (prevState.opbSearch.boardCode !== this.state.opbSearch.boardCode) {
            this.setTypeCodes();
        }
    }

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleValueChange = (e) => {
        const { name, value } = e.target;
        if (name === "damdangOrg" || name === "damdangRegion" || name === "damdangOffice") {
            // org, region, office 변경시 siteName, siteNum, opbNo 초기화
            this.setState({
                opbSearch: {
                    ...this.state.opbSearch,
                    siteName: '',
                    siteNum: '',
                    opbNo: '',
                    [name]: value
                },
                siteFinder: false
            });
        }
        else if (name === "siteName") {
            // siteName 입력시 siteNum, opbNo 초기화
            this.setState({
                opbSearch: {
                    ...this.state.opbSearch,
                    siteNum: '',
                    opbNo: '',
                    [name]: value
                },
                siteFinder: false
            });
        }
        else if (name === "siteNum") {
            if (value.length <= 6) {
                this.setState({
                    opbSearch: {
                        ...this.state.opbSearch,
                        siteName: '',
                        opbNo: '',
                        [name]: value
                    },
                    siteFinder: false
                });
            }
        }
        else if (name === "opbNo" || name === "elvNo" || name === "boardCode" || name === "typeCode" || name === "opbStatus") {
            this.setState({
                opbSearch: {
                    ...this.state.opbSearch,
                    [name]: value
                },
            });
        }
        else if (name === "listCount") {
            this.setState({
                currentPage: 1,
                listCount: value,
                siteFinder: false
            }, () => { this.setOpbInfoList(); });
        }
    };

    handleSiteInfo = (siteInfo) => {
        // siteFinder(현장찾기)에서 선택한 siteInfo의 소속, 현장명, PrjNo(현장번호) 입력
        // 선택된 site의 호기번호 정보를 가져옴
        this.setState({
            opbSearch: {
                ...this.state.opbSearch,
                damdangOrg: siteInfo.damdangOrg,
                damdangRegion: siteInfo.damdangRegion,
                damdangOffice: siteInfo.damdangOffice,
                siteName: siteInfo.siteName,
                siteNum: siteInfo.siteNum,
            },
            siteFinder: true
        });
    };

    handleSearchButton = () => {
        this.setState({
            currentPage: 1
        }, () => { this.setOpbInfoList(); });
    };

    getCurrentPage = (currentPage) => {
        this.setState({
            opbSearch: this.state.usedOpbSearch,
            currentPage: currentPage,
            siteFinder: false
        }, () => { this.setOpbInfoList(); });
    };

    setSelectedOpbInfo = (siteID, opbID) => {
        //Display 호기 선택 TAB 조회 
        let formData = new FormData();
        formData.append("siteID", siteID);
        formData.append("opbID", opbID);
        opbcdtService.selectedOpb(formData)
            .then(response => {
                this.setState({
                    selectedOpbInfo: response.data,
                    open: true
                });
            })
            .catch(this.handleErrors);
    };

    handleClosePreview = () => {
        this.setState({
            open: false
        });
    };

    // 엘리베이터_현황자료(현장별 관리호기정보) 엑셀 다운로드
    getPrjNOXls = () => {
        if (this.xlsLoading === true) {
            alert("엑셀 다운로드 중입니다. 잠시만 기다려주세요.");
        } else {
            //Display정보 엑셀 다운로드
            this.xlsLoading = true;
            let formData = new FormData();
            const { damdangOrg, damdangRegion, damdangOffice, siteName, siteNum, opbNo, boardCode, typeCode, opbStatus } = this.state.opbSearch;
            if (damdangOrg !== "") formData.append('damdangOrg', damdangOrg);
            if (damdangRegion !== "") formData.append('damdangRegion', damdangRegion);
            if (damdangOffice !== "") formData.append('damdangOffice', damdangOffice);
            if (siteName !== "") formData.append('siteName', siteName);
            if (siteNum !== "") formData.append('siteNum', siteNum);
            if (opbNo !== "") formData.append('opbNo', opbNo);
            if (boardCode !== "") formData.append('boardCode', boardCode);
            if (typeCode !== "") formData.append('typeCode', typeCode);
            if (opbStatus !== "") formData.append('opbStatus', opbStatus);

            opbMngService.getPrjNOXls(formData)
                .then(response => {
                    if (this.mounted) {
                        this.xlsLoading = false;
                        fileDownload(response.data, "엘리베이터_현황자료_" + utilHelper.getStringDate(new Date(), true, "_") + "_" + utilHelper.getStringTime(new Date(), true, "_") + ".xlsx");
                    }
                })
                .catch(this.handleErrors);
        }
    };

    render() {
        const { opbSearch, orgCodes, officeCodes, boardCodes, typeCodes, opbStatusCodes, isAdministratorRole, selectedOpbInfo, open } = this.state;
        const { totalCount, listCount, start, opbInfoList } = this.state;
        const { damdangOrg, damdangOffice, siteName, siteNum, elvNo, boardCode, typeCode, opbStatus } = opbSearch;
        const cellList = ["NO", "팀", "사무소", "PrjNo", "호기번호", "현장명", "승강기번호", "타입", "계약상태", "등록일", "관리설정", "더보기"];
        const listCounts = ["5", "10", "20", "50"];
        return (
            <React.Fragment>
                <OpbPreview opbInfo={selectedOpbInfo} open={open} handleClosePreview={this.handleClosePreview} />
                <h2 className="s-page-tit">
                    Display 검색
                </h2>
                <div className="search-wrapper opbmng-search s-normal-box">
                    <Row>
                        <Col xs={3} lg={1} className="col search-title">PrjNo</Col>
                        <Col xs={9} lg={3} className="col">
                            <SiteNumInputSiteFinder opbSearch={opbSearch} siteNum={siteNum} handleValueChange={this.handleValueChange} handleSiteInfo={this.handleSiteInfo} />
                        </Col>
                        <Col xs={3} lg={1} className="col search-title">현장명</Col>
                        <Col xs={9} lg={3} className="col">
                            <SiteNameInput siteName={siteName} handleValueChange={this.handleValueChange} />
                        </Col>
                        <Col xs={3} lg={1} className="col search-title"><div>승강기ID</div></Col>
                        <Col xs={9} lg={3} className="col">
                            <ElvNoInput elvNo={elvNo} handleValueChange={this.handleValueChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={3} lg={1} className="col search-title"><div>소속</div></Col>
                        <Col xs={9} lg={3} className="col">
                            <Row className="inner-row">
                                <Col>
                                    <DamdangOrgSelect orgCodes={orgCodes} damdangOrg={damdangOrg} handleValueChange={this.handleValueChange} disabled={isAdministratorRole} />
                                </Col>
                                <Col>
                                    <DamdangOfficeSelect officeCodes={officeCodes} damdangOrg={damdangOrg} damdangOffice={damdangOffice} handleValueChange={this.handleValueChange} disabled={isAdministratorRole} />
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={3} lg={1} className="col search-title">타입</Col>
                        <Col xs={9} lg={3} className="col">
                            <OpbTypeSelect boardCodes={boardCodes} typeCodes={typeCodes} boardCode={boardCode} typeCode={typeCode} handleValueChange={this.handleValueChange} />
                        </Col>
                        <Col xs={3} lg={1} className="col search-title">계약상태</Col>
                        <Col xs={9} lg={3} className="col">
                            <OpbStatusSelect opbStatusCodes={opbStatusCodes} opbStatus={opbStatus} handleValueChange={this.handleValueChange} />
                        </Col>
                    </Row>
                </div>
                <div className="search-button-wrapper">
                    <button className="button w100-button" onClick={this.handleSearchButton}>검색</button>
                </div>
                <div className="search-result-wrapper opbmng-mng s-normal-box">
                    <Row className="search-result-top">
                        <Col xs={12} sm={6} md={5} lg={3} className="contents-search-result">
                            <i>검색결과: {totalCount}</i>
                            <i><button className="button w98-button white-button" name="초기화" onClick={this.stateRefresh}><img src="/assets/images/ic-refresh.svg" className="ic-refresh" alt="초기화" />초기화</button></i>
                        </Col>
                        <Col xs={12} sm={2} md={2} lg={5}>&nbsp;</Col>
                        <Col xs={12} sm={4} md={5} lg={4} className="contents-search-count">
                            <i><button className="button w122-button white-button" name="엑셀 다운로드" onClick={this.getPrjNOXls}><img src="/assets/images/download_gray.svg" className="ic-refresh" alt="엑셀 다운로드" />엑셀 다운로드</button></i>
                            <i>
                                <select className="input-box padding-l10" name="listCount" value={listCount} onChange={this.handleValueChange}>
                                    {listCounts && listCounts.map((list, i) => {
                                        return <option key={i} value={list}>{list}건</option>;
                                    })}
                                </select>
                            </i>
                        </Col>
                    </Row>
                    <div style={{ overflow: "auto" }}>
                        <table className="opbmng-table" style={{ width: this.state.isMobile ? '1100px' : '100%' }}>
                            <thead className="table-head">
                                <tr>
                                    {cellList && cellList.map((cell, i) => {
                                        return <th key={i}>{cell}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {opbInfoList
                                    ?
                                    opbInfoList.length > 0
                                        ?
                                        opbInfoList.map((opbInfo, i) => {
                                            return <OpbItem key={i} no={totalCount - (start + i) + 1} opbInfo={opbInfo} stateRefresh={this.stateRefresh} handleClickOpenPreview={this.setSelectedOpbInfo} />;
                                        })
                                        :
                                        <tr>
                                            <td className="text-align-center" colSpan={cellList.length}>
                                                <div className="h300">
                                                    <img style={{ marginTop: '90px' }} src={"/assets/images/ic-no-result.svg"} alt="결과없음" /><br /><br />
                                                    검색결과가 없습니다.
                                                </div>
                                            </td>
                                        </tr>
                                    :
                                    <tr>
                                        <td className="text-align-center" colSpan={cellList.length}>
                                            <div className="text-align-center">
                                                <Loader type="Rings" color="#00BFFF" height={'50%'} width={'50%'} />
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <Pagination list={this.state} getCurrentPage={this.getCurrentPage} />
                </div>
            </React.Fragment>
        );
    }
}

function OpbItem({ no, opbInfo, stateRefresh, handleClickOpenPreview, }) {
    const { siteID, opbID, damdangOrg, damdangOffice, siteName, siteNum, opbNo, elvNo, boardCode, typeCode, opbStatus, regDate = "2020-01-01" } = opbInfo;

    const getStatusClassName = (opbStatus) => {
        let statusClassname = "";
        if (opbStatus === "ST001") statusClassname = "normal";
        else if (opbStatus === "ST002") statusClassname = "stop";
        else if (opbStatus === "ST003") statusClassname = "expired";

        return statusClassname;
    };

    return (
        <>
            <tr className="opbmng-item" style={{ backgroundColor: siteID === 0 ? "gainsboro" : "" }}>
                <td>{no}</td>
                <td>{utilHelper.getCodeName(damdangOrg) || "컨트롤센터"}</td>
                <td>{utilHelper.getCodeName(damdangOffice) || "컨트롤센터"}</td>
                <td>{siteNum}</td>
                <td>{opbNo}호기</td>
                <td>{siteName}</td>
                <td>{elvNo}</td>
                <td>{utilHelper.getCodeName(boardCode) + "." + utilHelper.getCodeName(typeCode)}</td>
                <td className={getStatusClassName(opbStatus)}>{utilHelper.getCodeName(opbStatus)}</td>
                <td>{utilHelper.getStringDate(new Date(regDate))}</td>
                <td>
                    <OpbMod opbInfo={opbInfo} stateRefresh={stateRefresh} />
                </td>
                <td>
                    <Link to={{ pathname: "/opbstate", state: { siteID: siteID } }}>
                        <button className="button w76-button gray-button">관리페이지</button>
                    </Link>
                    <button className="button w76-button blue-button" onClick={() => { handleClickOpenPreview(siteID, opbID); }}>화면보기</button>
                </td>
            </tr>
        </>
    );
}

function mapState(state) {
    const { userinfo } = state;
    const myInfo = userinfo.item;
    return { myInfo };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(OpbMng);